import { Component, OnInit } from '@angular/core';
import { GDPRManager } from './../../managers/gdpr.manager';
import { SharedService } from './../../shared';
import { Router, ActivatedRoute } from '@angular/router';
import { Utility } from './../../utils/utils';
import { TEXT, MESSAGES, STATUS } from './../../app.const';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss', '../../app.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(public mgr: GDPRManager, public sharedService: SharedService, public router: Router, public route: ActivatedRoute) { }
  addId: string;
  userData;
  showPrompt: Boolean;
  showError: Boolean;
  errorMsg: string;
  showEmailDialog: Boolean = false;
  showSuccessDialog = false;
  emailId = '';
  showData: Boolean = false;
  noData;
  public TEXT = TEXT;

  ngOnInit() {
    this.getStatus();
    this.route.queryParams.subscribe(params => {
      this.mgr.handleRoute(params);
    });
  }


  public getStatus() {
    this.mgr.getUserStatus().then(res => {
      if (res.status === STATUS.OptedOutInProgress) {
        // tslint:disable-next-line:max-line-length
        this.mgr.status = this.sharedService.prepareString(TEXT.optoutStatus, Utility.formatDate(res.opted_out_date), Utility.formatDate(res.estimated_opted_out_date));
        this.navigateToStatus();
      } else if (res.status === STATUS.OptedOut) {
        this.mgr.status = TEXT.deletedText;
        this.navigateToStatus();
      } else {
        this.showData = true;
      }
    }).catch((err) => {
      console.log(err);
      this.sharedService.displayErrorMsg(MESSAGES.ERROR);
    });
  }

  public navigateToStatus() {
    this.router.navigate(['/status'], {
      queryParams: this.mgr.getParams()
    });
  }

  public showDetails() {
    this.sharedService.showLoader = true,
      this.mgr.getUserData().then((res) => {
        if (res === null || Object.keys(res).length === 0) {
          this.showPrompt = true;
          this.noData = this.sharedService.prepareString(TEXT.noData, TEXT.idMap[this.mgr.platformType]);
          this.sharedService.showLoader = false;
        } else {
          this.showPrompt = true;
          this.userData = res;
          this.sharedService.showLoader = false;
        }
      }).catch((err) => {
        if (err && err.status === 503) {
          this.showPrompt = false;
          this.sharedService.showLoader = false;
          this.sharedService.displayErrorMsg(MESSAGES.ERROR);
        }
      });
  }

  public deleteData() {
    this.sharedService.showLoader = true;
    this.mgr.platformType === TEXT.webPlatform ?  this.renderIframe() : this.removeUserData();
  }

  removeUserData() {
    this.mgr.removeUserData().then((res) => {
      this.sharedService.showLoader = false;
      this.showError = true;
      this.errorMsg = TEXT.infoMsg;
    }).catch((err) => {
      this.sharedService.showLoader = false;
      this.showError = false;
      this.sharedService.displayErrorMsg(MESSAGES.ERROR);
    });
  } 

  renderIframe() {
    let iframe = document.createElement('iframe');
    iframe.style.display = "none";
    iframe.src = this.mgr.getSplOptoutUrl();
    document.body.appendChild(iframe);
    this.sharedService.showLoader = false;
    this.showError = true;
    this.errorMsg = TEXT.infoMsg;
  }

  public closePrompt() {
    this.showPrompt = false;
  }

  public isValidEmaiId() {
    const exp = /(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3}))+$/;
    const status = exp.test(this.emailId.trim());
    if (!status) {
      return status;
    }
    return true;
  }

  public goToEmailReport() {
    this.showEmailDialog = true;
  }

  public emailReport() {
    const payload = {};
    this.showEmailDialog = false;
    this.sharedService.showLoader = true;
    payload['email'] = this.emailId;
    this.mgr.emailReport(payload)
      .then(res => {
        this.sharedService.showLoader = false;
        this.showSuccessDialog = true;
        setTimeout(() => {
          this.showSuccessDialog = false;
        }, 3000);
      })
      .catch(err => {
        console.error(err);
        this.sharedService.showLoader = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/home/home.component.ts